import { Reveal } from "../Reveal";
import { MANIFESTO } from "../../lib/content";

export default function Manifesto() {
  return (
    <section id="about" className="relative py-24 md:py-36" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* left rail: heading */}
          <div className="lg:col-span-4">
            <div className="sticky top-28">
              <Reveal>
                <span className="text-xs uppercase tracking-[0.25em] text-gold">The Practitioner</span>
                <h2 className="font-serif text-4xl md:text-5xl font-light mt-4 leading-tight text-foreground">
                  A rare blend of <span className="text-gradient-gold italic">clinical, research and entrepreneurship.</span>
                </h2>
              </Reveal>
              <Reveal delay={0.15}>
                <p className="mt-8 text-muted-foreground leading-relaxed font-light md:text-lg max-w-sm">
                  Four principles shape how I work with clinicians, founders and institutions — from the first spark of an idea to a solution the field will actually adopt.
                </p>
              </Reveal>
            </div>
          </div>

          {/* right: numbered chapters */}
          <div className="lg:col-span-8">
            <div className="space-y-16">
              {MANIFESTO.map((ch, i) => (
                <Reveal key={ch.no} delay={i * 0.05}>
                  <div className="grid grid-cols-12 gap-6 items-start border-b border-gold/10 pb-14">
                    <div className="col-span-12 md:col-span-3">
                      <span className="font-serif text-6xl md:text-7xl text-gold/25 leading-none">{ch.no}</span>
                    </div>
                    <div className="col-span-12 md:col-span-9">
                      <h3 className="font-serif text-2xl md:text-3xl text-foreground mb-4">{ch.title}</h3>
                      <p className="text-muted-foreground leading-relaxed font-light md:text-lg">{ch.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
